export const ctaGetCashIcon = '/assets/images/cta-get-cash-icon.svg';
